import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClientViewState {
  active: boolean;
  userId: number | null;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isDataStorageUser: boolean;
  isCalibrateAdmin: boolean;
  isSuperuser: boolean;
}

export interface SetClientViewPayload {
  userId: number;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isDataStorageUser: boolean;
  isCalibrateAdmin: boolean;
  isSuperuser: boolean;
}

const initialState: ClientViewState = {
  active: false,
  userId: null,
  displayName: "",
  isChatBotAllowed: false,
  isIntegrationUser: false,
  isDataStorageUser: false,
  isCalibrateAdmin: false,
  isSuperuser: false,
};

const clientViewSlice = createSlice({
  name: "clientView",
  initialState,
  reducers: {
    setClientView: (state, action: PayloadAction<SetClientViewPayload>) => {
      const {
        userId,
        displayName,
        isChatBotAllowed,
        isIntegrationUser,
        isDataStorageUser,
        isCalibrateAdmin,
        isSuperuser,
      } =
        action.payload;
      state.active = true;
      state.userId = userId;
      state.displayName = displayName;
      state.isChatBotAllowed = isChatBotAllowed;
      state.isIntegrationUser = isIntegrationUser;
      state.isDataStorageUser = isDataStorageUser;
      state.isCalibrateAdmin = isCalibrateAdmin;
      state.isSuperuser = isSuperuser;
    },
    clearClientView: (state) => {
      state.active = false;
      state.userId = null;
      state.displayName = "";
      state.isChatBotAllowed = false;
      state.isIntegrationUser = false;
      state.isDataStorageUser = false;
      state.isCalibrateAdmin = false;
      state.isSuperuser = false;
    },
  },
});

export const { setClientView, clearClientView } = clientViewSlice.actions;
export default clientViewSlice.reducer;
